import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/social-3408791_1280.webp")